import {useState} from 'react'
import {graphql, useFragment} from 'react-relay'

import type {ProjectItemSection$key} from './__generated__/ProjectItemSection.graphql'
import styles from './ProjectItemSection.module.css'
import {ProjectItemSectionFieldList} from './ProjectItemSectionFieldList'
import {ProjectItemSectionView} from './ProjectItemSectionView'

export type ProjectItemSectionProps = {
  projectItem: ProjectItemSection$key
  isOpen: boolean
  onIssueUpdate?: () => void
}

export function ProjectItemSection({projectItem, onIssueUpdate, isOpen = false}: ProjectItemSectionProps) {
  const [open, setOpen] = useState(isOpen)
  const data = useFragment(
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    graphql`
      fragment ProjectItemSection on ProjectV2Item {
        id
        isArchived
        project {
          id
        }
        ...ProjectItemSectionView
      }
    `,
    projectItem,
  )

  return (
    <div className={styles.ProjectItemSectionContainer}>
      <ProjectItemSectionView
        projectItem={data}
        open={open}
        setOpen={setOpen}
        onIssueUpdate={onIssueUpdate}
        isProjectOpen={isOpen}
      />
      {open && (
        <ProjectItemSectionFieldList
          projectItemId={data.id}
          projectId={data.project.id}
          isArchived={data.isArchived}
          onIssueUpdate={onIssueUpdate}
        />
      )}
    </div>
  )
}

try{ ProjectItemSection.displayName ||= 'ProjectItemSection' } catch {}